"use client";

import { useEffect } from "react";
import Link from "@/components/ui/intent-link";

import { ErrorView, primaryBtnClass, secondaryBtnClass } from "@/components/error/error-view";
import { regionFromPathname, regionPath } from "@/lib/region";
import { usePublicPathname } from "@/lib/public-pathname";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const region = regionFromPathname(usePublicPathname());

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorView
      eyebrow="Something went wrong"
      title="This page didn't load properly"
      message="Sorry — something went wrong on our end. It's usually temporary, so please try again. If it keeps happening, we're here to help."
    >
      <button type="button" onClick={reset} className={primaryBtnClass}>
        Try again
      </button>
      <Link href={regionPath("/", region)} className={secondaryBtnClass}>
        Back to home
      </Link>
    </ErrorView>
  );
}
